import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CallbackType } from '@callback/const';
import { CallbackService } from '@callback/data-access';
import { DeviceService } from '@shared/services';

import { AsyncPipe } from '@angular/common';
import {
  PersonalDataAgreeTextCallbackComponent,
  PhoneAuthorizedUserDirective,
  PhoneMaskFixDirective,
  SdvorRadioComponent,
} from '@sdvor/shared/ui';
import { SdvorButtonComponent, SdvorInputComponent } from '@sdvor/shared/ui/v2';
import { StateUtils } from '@spartacus/core';
import { Observable } from 'rxjs';
import { ErrorMsgComponent, SuccessMsgComponent } from '../form-state-messages';

@Component({
  selector: 'sd-roof-request-modal',
  templateUrl: './roof-request-modal.component.html',
  styleUrls: ['./roof-request-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    SdvorInputComponent,
    SdvorRadioComponent,
    ReactiveFormsModule,
    SdvorButtonComponent,
    AsyncPipe,
    PersonalDataAgreeTextCallbackComponent,
    SuccessMsgComponent,
    ErrorMsgComponent,
    PhoneMaskFixDirective,
    PhoneAuthorizedUserDirective,
  ],
})
export class RoofRequestModalComponent implements OnInit, OnDestroy {
  callbackForm: FormGroup;
  currentCity: string;
  destroyRef = inject(DestroyRef);
  isMobile$: Observable<boolean>;
  formState$: Observable<StateUtils.LoaderState<unknown>>;

  constructor(
    private fb: FormBuilder,
    private callbackService: CallbackService,
    public deviceService: DeviceService,
  ) {}

  ngOnInit(): void {
    this.callbackForm = this.fb.group({
      phone: this.fb.control(null, { validators: [Validators.required, Validators.minLength(10)] }),
      address: this.fb.control(null, { validators: [Validators.required] }),
      isRoofTrussMounted: this.fb.control(null, [Validators.required]),
    });

    this.isMobile$ = this.deviceService.isMobileSmDown$;

    this.formState$ = this.callbackService.getProcess();
  }

  submitForm(): void {
    if (this.callbackForm.valid) {
      const callbackFormData = this.callbackForm.getRawValue();

      this.callbackService.requestCallback({
        type: CallbackType.ROOFREQUEST,
        phone: callbackFormData.phone,
        comment: '',
        address: callbackFormData.address,
        isRoofInstalled: callbackFormData.isRoofTrussMounted,
      });
    }
  }

  ngOnDestroy(): void {
    this.callbackService.resetProcess();
  }
}
